import {
  RESET_UPLOADS,
  SET_UPLOADING,
  SET_PROGRESS,
  DONE_UPLOADING,
  SET_UPLOAD_ERROR,
  CANCEL_UPLOAD,
  CLEAR_SC_ERRORS,
  SET_UPLOADER,
  SET_UPLOAD_RESULTS,
} from '../actions/types';

const initialState = {
  failedFiles: [], // Only used by SC upload flow
  progress: 0,
  uploading: false,
  uploadComplete: false,
  uploadError: false, // Only used by SC upload flow
  uploader: null,
  // Which files in the last batch uploaded, so the form can drop them and
  // keep the failed or cancelled ones for retry
  uploadResults: null,
};

export default function claimDetailReducer(state = initialState, action) {
  switch (action.type) {
    case RESET_UPLOADS: {
      return initialState;
    }
    case SET_UPLOADING: {
      return {
        ...state,
        failedFiles: [],
        uploading: action.uploading,
        uploadError: false,
        uploadComplete: false,
        uploader: action.uploader,
        uploadResults: null,
      };
    }
    case SET_UPLOAD_RESULTS: {
      return {
        ...state,
        uploadResults: {
          succeededIndexes: action.succeededIndexes,
          fileCount: action.fileCount,
        },
      };
    }
    case SET_UPLOADER: {
      return {
        ...state,
        uploader: action.uploader,
      };
    }
    case SET_PROGRESS: {
      return {
        ...state,
        progress: action.progress,
      };
    }
    case DONE_UPLOADING: {
      return {
        ...state,
        uploading: false,
        uploadComplete: true,
        uploader: null,
      };
    }
    case SET_UPLOAD_ERROR: {
      // Only used by SC upload flow
      const { fileName, fileType } = action.payload;
      const files = [...state.failedFiles];

      files.push({
        fileName,
        fileType,
      });

      return {
        ...state,
        failedFiles: files,
        uploadError: true,
        uploader: null,
      };
    }
    case CLEAR_SC_ERRORS: {
      return {
        ...state,
        failedFiles: [],
        uploadError: false,
      };
    }
    case CANCEL_UPLOAD: {
      return {
        ...state,
        uploading: false,
        uploader: null,
      };
    }
    default:
      return state;
  }
}
